import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-booking-item-setting-field-capacity-available',
    templateUrl: './editor-booking-item-setting-field-capacity-available.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldCapacityAvailableComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;

  constructor() {

  }

  ngOnInit() {

  }
}
